<template>
  <div class="result" >
    <!-- <add-ut /> -->
    <ui-loading-circle :descText="'downloadingDot'" :applyBackground="true" v-if="!isLoaded"/>
    <result-menu :active="'visit'" :utid="utid" />
    <template v-if="isLoaded">
      <div class="bridge-content">
        <h5>
          <span class="list-check" :class="{'active': isSimple}" @click="isSimple = !isSimple"></span>
          simple로 URL 묶기
        </h5>
        <div class="visit-table">
          <ul>
            <li>
              <span>Rank</span>
              <span>URL</span>
              <span>PV</span>
              <span>Session</span>
            </li>
            <template v-if="visit_list.length > 0">
              <template v-for="(visit, index) in visit_list">
                <li v-bind:key="index">
                  <span>{{index+1}}</span>
                  <span>{{visit.url}}</span>
                  <span>{{visit.pv | thousand}}</span>
                  <span>{{visit.uv | thousand}}</span>
                </li>
              </template>
            </template>

            <template v-else>
              <li class="data-none">
                <img src="@/assets/images/icon-ui-visit-none.svg" alt="">
                <p>UT방문통계가 없습니다.</p>
              </li>
            </template>

          </ul>
        </div>
      </div>
      <p>뷰저블에 등록되지 않은 페이지로 전환된 URL은 수집되지 않았습니다.</p>
    </template>

  </div>
</template>

<script>
import ResultMenu from '@/components/result/ResultMenu'
import { getUtResultVisit } from '@/api/ut'
export default {
  name: 'ResultVisit',
  components: {
    ResultMenu
  },
  props: [
    'utid'
  ],
  data () {
    return {
      isLoaded: false,
      isSimple: false,
      visit_list: [

      ]
    }
  },
  watch: {
    isSimple: {
      async handler () {
        await this.getData()
      }
    }
  },
  async created () {
    await this.getData()
  },
  methods: {
    getData () {
      this.isLoaded = false
      const params = {
        utid: this.utid,
        simple: this.isSimple
      }
      getUtResultVisit(params).then(result => {
        if (result.success) {
          this.visit_list = result.result
        }
        this.isLoaded = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.result {
  margin: 90px auto 0;
  padding-bottom: 160px;
  & > p {
    font-size: 13px;
    color: #1990c2;
    text-align: center;
    margin-top: 30px;
  }
  & > h1 {
    width: 990px;
    font-size: 20px;
    font-weight: 500;
    color: #2f2f2f;
    margin: 0 auto;
    & span {
      display: inline-block;
      width: 32px;
      height: 32px;
      vertical-align: top;
      border-radius: 5px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.06);
      background: #fff url('../../../assets/images/icon-page-back.svg') no-repeat center;
      margin-right: 30px;
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        background: #f7f7f7 url('../../../assets/images/icon-page-back.svg') no-repeat center;
      }
    }
    & > button {
      display: inline-block;
      margin: 0px 40px 0 0;
      padding-bottom: 8px;
      color: #999;
      vertical-align: top;
      cursor: default;

      &.active {
        border-bottom: 3px solid #ec0047;
        color: #2f2f2f;
        cursor: pointer;
      }
    }
  }
  .bridge-content {
    width: 990px;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.10), 0 0 0 1px rgba(0, 0, 0, 0.10);
    background: #fff;
    padding: 10px 10px 10px 10px;
    box-sizing: border-box;
    margin: 30px auto 0;
    h5 {
      font-size: 13px;
      color: #444;
      display: block;
      line-height: 1px;
      padding: 10px 0 20px;

      .list-check {
        position: relative;
        display: inline-block;
        width: 30px;
        height: 18px;
        top: 4px;
        left: 5px;
        border-radius: 11px;
        background: #d7d7d7;
        cursor: pointer;
        margin-right: 12px;
        &::before {
          content: "";
          position: absolute;
          top: 2px;
          left: 2px;
          width: 14px;
          height: 14px;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.18);
          background-color: #fff;
          border-radius: 50%;
        }
        &.active {
          background: #3eaa08;
          &::before {
            content: "";
            position: absolute;
            top: 2px;
            left: auto;
            right: 2px;
          }
        }
      }
    }
    .visit-table {
      ul {
        border: 1px solid #ebebeb;
        border-radius: 6px;
        li {
          height: 65px;
          line-height: 65px;
          font-size: 13px;
          font-weight: 500;
          color: #444;
          border-bottom: 1px solid #ebebeb;
          &:first-child {
            height: 55px;
            line-height: 18px;
            font-size: 13px;
            font-weight: 500;
            padding-top: 27px;
            box-sizing: border-box;
            color: #fff;
            background: #333;
            border-top-right-radius: 6px;
            border-top-left-radius: 6px;
          }
          span {
            display: inline-block;
            &:nth-child(1) {
              width: 10%;
              text-align: center;
            }
            &:nth-child(2) {
              width: 60%;
            }
            &:nth-child(3) {
              width: 15%;
              text-align: center;
            }
            &:nth-child(4) {
              width: 15%;
              text-align: center;
            }
          }
          &.data-none {
            text-align: center;
            padding: 90px 0 110px;
            line-height: 1.46;
            border-bottom-right-radius: 6px;
            border-bottom-left-radius: 6px;
            border-bottom: none;
            p {
              font-size: 13px;
              color: #444;
              margin-top: 5px;
            }
          }
        }
      }
    }
  }
}

@media all and (max-width: 990px) {
  .result {
      min-width: 768px;

      & > h1 {
          width: calc(100% - 40px);
      }
      .bridge-content {
          position: relative;
          width: calc(100% - 40px);
          height: auto;
      }
  }
}
</style>
